module.exports = __webpack_public_path__ + "static/img/login-list-icon-kakao.d08d3b53.svg";